import { useTranslation } from 'react-i18next'
import { CampaignCreateParams, Subscription } from '../../../types'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { useEffect, useMemo } from 'react'
import { SingleSelect } from '../../../ui/form/SingleSelect'

interface SubscriptionSelectionParams {
    subscriptions: Subscription[]
    form: UseFormReturn<CampaignCreateParams>
}

export default function CampaignSubscriptionSelection({ subscriptions, form }: SubscriptionSelectionParams) {
    const { t } = useTranslation()
    const channel = useWatch({
        control: form.control,
        name: 'channel',
    })
    subscriptions = useMemo(() => channel ? subscriptions.filter(s => s.channel === channel && !s.is_channel) : [], [channel, subscriptions])
    useEffect(() => {
        if (channel && subscriptions.length) {
            const { subscription_id } = form.getValues()
            if (!subscription_id || !subscriptions.find(s => s.id === subscription_id)) {
                form.setValue('subscription_id', subscriptions[0].id)
            }
        }
    }, [channel, form, subscriptions])
    return (
        <SingleSelect.Field
            form={form}
            name="subscription_id"
            label={t('subscription_group')}
            options={subscriptions}
            required
            toValue={x => x.id}
        />
    )
}
